module.exports = __webpack_public_path__ + "2e01da90470173494497784341155d71.svg";